export default {
  notificationsMessage: {
    english: "Please choose what type of notifications would you like to receive",
    spanish: "Por favor elija que tipo de notificaciones le gustaría recibir"
  },
  notificationSettings: {
    english: "Notification Settings",
    spanish: "Configuración de las notificaciones"
  },
  options: {
    english: "Options",
    spanish: "Opciones"
  },
  pushNotifications: {
    english: "Push Notifications",
    spanish: "Notificaciones push"
  },
  smsMessages: {
    english: "SMS Messages",
    spanish: "Mensajes SMS"
  },
  videoChats: {
    english: "Video Chats",
    spanish: "Chats de video"
  },
  textChats: {
    english: "Text Chats",
    spanish: "Chats de texto"
  },

  fileUploads: {
    english: "File Uploads",
    spanish: "Subidas de archivos"
  },
  profileUpdates: {
    english: "Profile Updates",
    spanish: "Actualizaciones de perfil"
  },
  saveChanges: {
    english: "Save Changes",
    spanish: "Guardar cambios"
  },
  save: {
    english: "Save",
    spanish: "Guardar"
  },
  clearAll: {
    english: "Clear All",
    spanish: "Limpiar todo"
  },
  saving: {
    english: "Saving...",
    spanish: "Guardando..."
  },
  cancel: {
    english: "Cancel",
    spanish: "Cancelar"
  },
  typeOfNotifications: {
    english: "Type of Notifications",
    spanish: "Tipo de notificaciones"
  },
  email: {
    english: "Email",
    spanish: "Correo electrónico"
  },
  questionnaires: {
    english: "Questionnaires",
    spanish: "Cuestionarios"
  }
};
